/** @jsx React.DOM */

var _ = require("lodash");
var React = require("react/addons");
var TerminalsActions = require("editor/actions/TerminalsActions");
var TerminalsStore = require("editor/stores/TerminalsStore");

var Terminal = require("./Terminal");

var WatchStoreMixin = require("editor/mixins/WatchStore");

var TerminalsBox = React.createClass({displayName: 'TerminalsBox',
  mixins: [WatchStoreMixin(TerminalsStore)],

  getFluxState: function() {
    return {
      terminals: TerminalsStore.getAll()
    };
  },

  renderTabHeaders: function() {
    return _.map(this.state.terminals, function(terminal) {
      var tabClasses = React.addons.classSet({
        "active": terminal.current
      });

      return React.DOM.li({key: "tab_" + terminal.id, className: tabClasses}, 
        React.DOM.a({href: "#"}, 
          React.DOM.span({onClick: this.selectTerminal.bind(this, terminal)}, "terminal_" + terminal.id), 
          React.DOM.span({className: "glyphicon glyphicon-remove", onClick: this.closeTerminal.bind(this, terminal)})
        )
      );
    }, this);
  },

  renderTerminals: function() {
    return _.map(this.state.terminals, function(terminal) {
      var classes = React.addons.classSet({
        "tab-pane": true,
        "fade active in": terminal.current
      });

      return (
        React.DOM.div({className: classes, key: terminal.id}, 
          Terminal({terminal: terminal})
        )
      );
    });
  },

  render: function() {
    return (
      React.DOM.div(null, 
        React.DOM.ul({className: "nav nav-tabs", role: "tablist"}, 
          this.renderTabHeaders(), 
          React.DOM.li({key: "tab_create"}, 
            React.DOM.a({href: "#", onClick: this.createTerminal}, "Create terminal")
          )
        ), 
        React.DOM.div({className: "tab-content"}, 
          this.renderTerminals()
        )
      )
    );
  },

  selectTerminal: function(terminal) {
    TerminalsActions.selectTerminal(terminal);
  },

  createTerminal: function() {
    //FIXME: вынести куда нибудь в конфиг
    TerminalsActions.createTerminal({
      cols: 160,
      rows: 24
    });
  },

  closeTerminal: function(terminal) {
    TerminalsActions.closeTerminal(terminal);
  },
});

module.exports = TerminalsBox;



/*****************
 ** WEBPACK FOOTER
 ** ./src/editor/components/terminals/TerminalsBox.js
 ** module id = 30
 ** module chunks = 0
 **/